export const enum EntityTypeKey {
  Project = 'Project',
  Message = 'Message',
  GastroFlowHood = 'GastroFlowHood',
  GastroFlowHoodLine = 'GastroFlowHoodLine',
  GastroFlowHoodConnectionLine = 'GastroFlowHoodConnectionLine',
  GastroFlowModule = 'GastroFlowModule',
  GastroFlowOutsidePanel = 'GastroFlowOutsidePanel'
}

/**
 * Check if the provided entity key is a hood
 * @param typeKey The EntityTypeKey
 */
export const isHood = (typeKey: string): boolean => {
  // Note: in the future we will have more hoods than just GastroFlow. Extend this function as required.
  return typeKey === EntityTypeKey.GastroFlowHood;
};
